'use strict';

import auditTrails from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        auditTrail: {},
        auditTrails: [],
        auditTrailsUserAction: []
    },
    getters: {
        getAuditTrail: (state) => state.auditTrail,
        getAuditTrails: (state) => state.auditTrails,
        getAuditTrailsUserAction: (state) => state.auditTrailsUserAction
    },
    mutations: {
        SET_AUDIT_TRAIL(state, value) {
            state.auditTrail = value;
        },
        SET_AUDIT_TRAILS(state, value) {
            state.auditTrails = value;
        },
        SET_AUDIT_TRAILS_USER_ACTION(state, value) {
            state.auditTrailsUserAction = value;
        },
        CLEAR_STATE(state) {
            state.auditTrail = {};
            state.auditTrails = [];
        }
    },
    actions: {
        fetchAuditTrails(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                auditTrails
                    .getData({ to: '/cms-audit-logs', config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_AUDIT_TRAILS', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_AUDIT_TRAILS', []);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        fetchAuditTrailsUserAction(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                auditTrails
                    .getData({ to: '/cms-audit-logs/index-by-user-action', config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_AUDIT_TRAILS_USER_ACTION', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_AUDIT_TRAILS_USER_ACTION', []);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findAuditTrail(context, payload) {
            console.log(payload);
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                auditTrails
                    .getData({ to: `/cms-audit-logs/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_AUDIT_TRAIL', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_AUDIT_TRAIL', {});
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
